module.exports = __webpack_public_path__ + "img/icon_map_0_on_010.bdd884b7.png";